import ar_white from "../../../assets/images/ar_white.svg";
import home_white from "../../../assets/images/home_white.svg";

import aboutus_mobi from "../../../assets/images/aboutus_mobi.webp";
import aboutus_pc from "../../../assets/images/aboutus_pc.webp";

export default function AboutUsBanner() {
  return (
    <div className="w-full">
      <div className="block md:hidden lg:hidden w-full relative h-[12rem] mt-16">
        <img src={aboutus_mobi} alt="mobi" className="w-full h-[12rem] object-cover" />
        <div className="w-full absolute top-0 bg-blue-sky-gradient6 h-[12rem]">
          <div className="absolute bottom-[30%] left-1/2 -translate-x-1/2 flex flex-col gap-2 items-center justify-center px-4">
            <div className="w-full max-w-xs h-[2.625rem] rounded-[40px] flex items-center justify-center gap-2">
              <img src={home_white} alt="home1" className="w-5 h-5" />
              <img src={ar_white} alt="ar" className="w-4 h-4" />
              <p className="text-sm md:text-base font-normal text-white">Về chúng tôi</p>
            </div>
            <p className="text-xl md:text-2xl font-semibold text-white text-center">
              Về chúng tôi
            </p>
          </div>
        </div>
      </div>
      <div className="hidden md:block lg:block w-full relative h-[20rem] mt-28">
        <img src={aboutus_pc} alt="pc" className="w-full h-[20rem] object-cover" />
        <div className="w-full absolute top-0 bg-blue-sky-gradient6 h-[20rem]">
          <div className="absolute bottom-[35%] left-1/2 -translate-x-1/2 flex flex-col gap-2 items-center justify-center px-4">
            <div className="w-full max-w-xs p-1 h-[2.625rem] rounded-[40px] text-white flex items-center justify-center gap-2">
              <img src={home_white} alt="home1" className="text-white w-5 h-5" />
              <img src={ar_white} alt="ar" className="w-4 h-4" />
              <p className="text-sm md:text-base lg:text-lg font-normal text-white">
                Về chúng tôi
              </p>
            </div>
            <p className="text-2xl md:text-3xl lg:text-4xl font-semibold text-white text-center">
              Về chúng tôi
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
